import styles from "./Item.module.css";
// import SelectTime from "./../../../SelectCenter/Centers/SelectTime/SelectTime";

// icons
// import { ReactComponent as EditIcon } from "./../../../../../assets/svg/edit.svg";
// import { ReactComponent as TrashIcon } from "./../../../../../assets/svg/trash.svg";

const Item = (props) => {
  const {
    active,
    onClick,
    address,
    id,
    noCheckbox,
    company_name
  } = props;

  return (
    <>
      <div onClick={onClick} className={styles.Item} key={id}>
        <div className={styles.TitleEditContainer}>
          {!noCheckbox && <div
            className={`${styles.CheckboxCircleContainer} ${active ? styles.Active : ""
              }`}
          >
            <div
              className={`${styles.CheckboxCircle} ${active ? styles.Active : ""
                }`}
            />
          </div>}
          <div className={styles.Address}>{company_name !== '' ? company_name : address}</div>
        </div>
      </div>
    </>
  );
};

export default Item;
